import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-slug-page',
  templateUrl: './slug-page.component.html',
  styleUrls: ['./slug-page.component.scss'],
})
export class SlugPageComponent implements OnInit {
  slug!: any;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.slug = this.route.snapshot.paramMap.get('slug');
  }
}
